import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";

type loaderProps = {
  isLoading: boolean;
};

const Loader = ({ isLoading }: loaderProps) => {
  return (
    <Backdrop
      invisible
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
      open={isLoading}
    >
      <CircularProgress color="primary" />
    </Backdrop>
  );
};

export default Loader;
